export const props = {
  update: Function
}
